import { EFieldType, FieldModelByKey } from "@/views/Counterparties/interface";
import { FormItemCommon } from "@/components/Form/interface";

export const fieldsWithoutModel: EFieldType[] = [
	EFieldType.DIVIDER
];

export const fieldModelByKey: FieldModelByKey = {
	[EFieldType.FILE]: () => [],
	[EFieldType.CHECKBOX]: () => false,
	[EFieldType.SWITCH_WITH_LABEL]: () => false,
} as FieldModelByKey;

export const getDefaultModelByKey = (type: EFieldType): any =>
	(fieldModelByKey.hasOwnProperty(type) && fieldModelByKey[type]()) || '';

export const setFieldModel = (
	field: FormItemCommon<any>
): FormItemCommon<any> => {
	if (!fieldsWithoutModel.includes(field.type!))
		field.model = getDefaultModelByKey(field.type!);

	return field;
};